import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const fetchLiveLogs = createAsyncThunk<
    { productGuid: string; logsBatch: any[] },
    { productGuid: string; signal: AbortSignal },
    ThunkConfig<string>
>('logsSlice/fetchLiveLogs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { productGuid, signal } = args
    try {
        const { data } = await api.get(
            getUrlWithVersion(`/logs/${productGuid}/batch`),
            {
                signal,
                params: {
                    count: 1000,
                },
            }
        )

        const logsBatch = data['log_batch'] ?? []

        return { productGuid, logsBatch }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch live logs')
    }
})
